import { isotope } from 'isotope-layout/dist/isotope.pkgd.min';

$(function() {
    let $grid = $('.js-grid'),
        $filterBtns = document.querySelectorAll('.js-filter-btn');

    $grid.isotope({
        itemSelector: '.js-grid-item',
        layoutMode: 'fitRows',
        gutter: 0
    });

    $filterBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            let filterValue = this.dataset.filter;
            $filterBtns.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');
            $grid.isotope({ filter: filterValue });
        });
    });
});